'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/sonner';
import CookieConsent from '@/components/shared/CookieConsent';
import { PostHogProvider } from '@/components/shared/PostHogProvider';
import { GoogleTagManagerProvider } from '@/components/shared/GoogleTagManagerProvider';
import { useState } from 'react';

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <GoogleTagManagerProvider />
        <PostHogProvider>{children}</PostHogProvider>
        <Toaster />
        <CookieConsent />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
